module.exports = __webpack_public_path__ + "static/img/20240426_5.b3db83a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240426_5.png
// module id = oKfh
// module chunks = 0